module.exports = __webpack_public_path__ + "media/localization/ukrainian-1aa23531.png";